import { Badge, Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const PredefinedLeasingSelectorWrapper = styled.section`
    margin: 0;
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
    position: relative;
`;

export const SummaryTable = styled.div`
    margin-top: ${getPurpurSpacing('300')};
`;

export const PaymentTypeSelectorWrapper = styled.div.attrs({ role: 'radiogroup', dir: 'ltr' })`
    margin: ${getPurpurSpacing('300')} 0;
    display: flex;
    gap: ${getPurpurSpacing('200')};
`;

export const BadgeStyled = styled(Badge)`
    margin-left: auto;
`;

export const SelectTitle = styled(Heading)`
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('50')};
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${getPurpurSpacing('200')};
    & + & {
        margin-top: ${getPurpurSpacing('100')};
    }
`;

export const DiscountWrapper = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('200')};

    > :nth-child(1) {
        order: 2;
    }
    > :nth-child(2) {
        order: 1;
    }
`;
